import { all, takeLatest, put, call } from 'redux-saga/effects';

import cookie from '@snapask/common-components/dist/utils/cookie';

import i18n from '@blueberry/i18n';

import { types } from '@blueberry/redux/auth';
import { actions as profileActions } from '@blueberry/redux/profile';
import { showAlertBanner } from '@blueberry/redux/alertBanner';
import { showAlertModal } from '@blueberry/redux/alertModal';
import { home } from '@blueberry/redux/navigation';
import { fetchSiteInfo } from '@blueberry/redux/siteInfo';
import { actions as errorActions } from '@blueberry/redux/error';

import { logout } from '@blueberry/services/apis';

import { ALERT_SUCCESS_THEME } from '@blueberry/constants/alertBannerThemes';
import { TOKEN_AMOUNT_EXCEED } from '@blueberry/constants/errorCode';

import config from '@blueberry/config';

function* discardUserAuth() {
  yield put(fetchSiteInfo());

  const snapCookie = new cookie(config.COOKIE_DOMAIN);
  snapCookie.deleteAuthCookie();

  yield put(profileActions.resetUser());
}

export function* logoutFlow() {
  try {
    yield call(logout);
    yield call(discardUserAuth);
    yield put(
      showAlertBanner({
        message: 'common:common.logoutSuccess',
        theme: ALERT_SUCCESS_THEME,
      })
    );
    yield put(home());
  } catch (error) {
    yield put(errorActions.sendError(error));
  }
}

export function* forceLogoutFlow(action) {
  const { errorCode } = action.payload;
  yield call(discardUserAuth);

  const modalDescription =
    errorCode === TOKEN_AMOUNT_EXCEED
      ? i18n.t('common:common.deviceAmountExceed')
      : i18n.t('common:common.tokenExpired');

  yield put(
    showAlertModal({
      title: i18n.t('common:common.forceLogout.title'),
      description: modalDescription,
      closeButtonText: i18n.t('common:common.forceLogout.closeButtonText'),
    })
  );
}

export default function*() {
  yield all([
    takeLatest(types.LOGOUT, logoutFlow),
    takeLatest(types.FORCE_LOGOUT, forceLogoutFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/auth.js